import dynamic from 'next/dynamic'
import { useState, useEffect, useRef, memo } from 'react'

import { NormalizedWrapper } from '@theme'
import { Description } from '@ui/sections/Description'

import { Wrapper, WrapperPlayer } from './styles'

const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false })

function LoopPlayerComponent({
  title,
  wrapHeight,
  url,
  width = '100%',
  preload = 'none',
}) {
  const ref = useRef()

  const [playerHeight, setPlayerHeight] = useState(0)
  const [scrollTop, setScrollTop] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)

  const scrollHandler = () => {
    if (ref.current) {
      const windowInnerHeight = window.innerHeight
      const rect = ref.current.getBoundingClientRect()
      const positionTop = (playerHeight / 100) * 40
      const positionBottom = (playerHeight / 100) * 60
      const workArea =
        scrollTop - windowInnerHeight < -positionTop &&
        scrollTop + positionBottom > 0

      if (workArea) {
        setIsPlaying(true)
      } else {
        setIsPlaying(false)
      }

      setPlayerHeight(rect.height)
      setScrollTop(rect.top)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler)
    return () => {
      window.removeEventListener('scroll', scrollHandler)
    }
  }, [scrollTop])
  return (
    <Wrapper>
      <NormalizedWrapper>
        <Description title={title} />
      </NormalizedWrapper>
      <WrapperPlayer
        className="player-wrapper"
        ref={ref}
        wrapHeight={wrapHeight}
      >
        <ReactPlayer
          className="react-player"
          url={url}
          width={width}
          height="100%"
          volume={0}
          loop
          muted
          playing={isPlaying}
          playsinline
          config={{
            file: {
              attributes: {
                preload,
                loading: 'lazy',
              },
            },
          }}
        />
      </WrapperPlayer>
    </Wrapper>
  )
}

export const LoopPlayer = memo(LoopPlayerComponent)
